import { Autocomplete, Box, Grid, TextField, Typography } from '@mui/material';
import PermissionsStyles from '../../../../components/Permissions/styles/PermissionsStyles';
import { userLabel } from './agentManagerUtils';

const sameEmail = (a, b) => (a.Email || '').toLowerCase() === (b.Email || '').toLowerCase();

// The manager is picked from the portal users (Permissions page); the email
// is taken from the chosen user and shown read-only.
const ManagerPicker = ({ users, value, onChange }) => (
  <Grid item container spacing={3}>
    <Grid item xs={12} md={6}>
      <Autocomplete
        options={users}
        value={value}
        onChange={(_, selected) => onChange(selected)}
        getOptionLabel={userLabel}
        isOptionEqualToValue={sameEmail}
        renderOption={(props, u) => (
          <li {...props} key={u._id}>
            <Box display="flex" flexDirection="column">
              <span>{userLabel(u)}</span>
              <Typography variant="caption" color="text.secondary" dir="ltr">
                {u.Email}
              </Typography>
            </Box>
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="מנהל אחראי" required sx={PermissionsStyles.textField} />}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <TextField
        label="מייל מנהל"
        value={value?.Email || ''}
        fullWidth
        InputProps={{ readOnly: true }}
        helperText="נלקח מעמוד ההרשאות"
        sx={PermissionsStyles.textField}
      />
    </Grid>
  </Grid>
);

export default ManagerPicker;
